export default {
  namespaced: true,
  state: {
    zipcode: '',
    formComponentData: null,
    isChange: false,
    setCache: false,
  },
  mutations: {
    updateZipcode(state, payload) {
      state.zipcode = payload;
    },
    updateChangeValue(state, payload) {
      state.isChange = payload;
    },
    updateSetCacheValue(state, payload) {
      state.setCache = payload;
    },
    storeData(state, payload) {
      state.formComponentData = payload;
    },
  },
};
